import { useEffect } from 'react'

import { CUSTOM_EVENTS } from '@/constants/events'
import { useUpdateUserCount } from '@/pages/tad.ai/_layout/Header/_useHooks/useUpdateUserCount'

/**
 * 自动监听用户使用量更新事件并触发更新
 */
export function useAutoUpdateSubUsage() {
  const { updateUserCount } = useUpdateUserCount()
  useEffect(() => {
    const handleAutoUpdateSubUsage = () => {
      updateUserCount()
    }

    // 监听自动更新用户使用量事件
    window.addEventListener(
      CUSTOM_EVENTS.AUTO_UPDATE_SUB_USAGE,
      handleAutoUpdateSubUsage,
    )

    // 清理事件监听器
    return () => {
      window.removeEventListener(
        CUSTOM_EVENTS.AUTO_UPDATE_SUB_USAGE,
        handleAutoUpdateSubUsage,
      )
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps -- 注意：这里依赖数组为空，因为我们通过 ref 获取最新值
}
